export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ERNST = '/ernst'
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_RESET = '/password-reset';